var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotSharpshooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}.cls-2{fill:#4f5656;}.cls-3{fill:#3c3f3f;}.cls-4{fill:#ab19af;}.cls-5{fill:#262828;}.cls-6{fill:#f4f4f2;}.cls-7{fill:#ffbb43;}.cls-8{fill:#fa0;}.cls-9{fill:#ad7214;}.cls-10{fill:#a58a4c;}.cls-11{fill:#777c7b;}.cls-12{fill:#f0f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.71,
    y: 123.45,
    width: 36.61,
    height: 12.2,
    transform: "translate(-22.22 217.13) rotate(-55.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.45,
    y: 131.4,
    width: 205.73,
    height: 9.23,
    transform: "translate(-26.12 222.68) rotate(-55.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "272.94 17.71 268.44 17.48 246.01 50.46 246.81 53.71 255.42 59.57 258.74 59.12 280.86 26.66 279.3 22.04 272.94 17.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 262.82,
    y: 33.96,
    width: 12.19,
    height: 3,
    transform: "translate(88.37 237.89) rotate(-55.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 272.4,
    y: 25.18,
    width: 5.18,
    height: 3,
    transform: "translate(98.29 239.07) rotate(-55.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "219.57 121.43 147.9 226.81 143.58 223.87 227.41 100.61 219.57 121.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "268.07 17.57 258.62 31.45 257.01 30.36 264.3 15 268.07 17.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "221.5 86.05 208.84 104.66 164.92 164.59 159.15 160.67 198.75 97.79 211.4 79.18 221.5 86.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 40.89,
    y: 179.54,
    width: 199.63,
    height: 109.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "53.97 292 -0.59 292 -6.86 216.13 17.35 149.91 42.63 156.01 58.33 184.14 60.88 251.46 53.97 292"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "226.06 292 280.63 292 286.89 216.13 262.68 149.91 237.4 156.01 221.71 184.14 219.15 251.46 226.06 292"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "162.65 21.12 117.3 21.12 76.43 45.8 48.15 196.23 64.58 191.81 65.83 209.5 94.11 205.17 117.3 224.85 139.97 211.58 162.65 224.85 185.83 205.17 214.12 209.5 215.37 191.81 231.8 196.23 203.52 45.8 162.65 21.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "139.97 136.91 93.3 121.18 139.97 114.31 186.65 121.18 139.97 136.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "125.95 87.55 122.73 122.03 139.75 161.79 156.78 122.03 153.56 87.55 139.75 79.98 125.95 87.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "120.98 95.1 98.43 95.1 85.17 81.83 108.38 84.04 120.98 95.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "158.44 95.1 180.99 95.1 194.25 81.83 171.04 84.04 158.44 95.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "127.91 105.11 133.85 102.25 136.15 96.1 127.91 105.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "151.62 105.11 145.68 102.25 143.39 96.1 151.62 105.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "128.92 110.33 83.51 122.64 61.57 122.68 67.76 58.34 82.3 57.25 128.92 69.81 128.92 110.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.03 79.56 85.03 100.32 103.01 110.7 120.98 100.32 120.98 79.56 103.01 69.19 85.03 79.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "88.36 81.48 88.36 98.39 103.01 106.85 117.65 98.39 117.65 81.48 103.01 73.03 88.36 81.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.31 127.53 51.54 122.51 62.98 56.63 74 54.52 61.31 127.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.39 240.57 75.47 240.57 75.47 234.47 133 234.47 130.39 240.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "127.77 251.9 75.47 251.9 75.47 245.8 130.39 245.8 127.77 251.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotSharpshooter);
export default __webpack_public_path__ + "static/media/pilot-sharpshooter.06e1276c07826fe6f53479638b86e2e0.svg";
export { ForwardRef as ReactComponent };